import React, { useEffect, useState } from 'react'
import Overlay from 'react-bootstrap/Overlay'
import BootstrapTooltip from 'react-bootstrap/Tooltip'

const Tooltip = ({ active, time = 2000, text, placement = 'bottom', target, onHide }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    let timerId = null

    if (active && target) {
      setShow(true)
      timerId = setTimeout(() => {
        setShow(false)
        onHide()
      }, time)
    } else {
      setShow(false)
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId)
      }
    }
  }, [active, time, target, onHide])

  if (!target) {
    return null
  }

  return (
    <Overlay target={target} show={show} placement={placement}>
      {(props) => (
        <BootstrapTooltip
          id={`tooltip-${placement}-${Math.random().toString(36).substring(7)}`}
          {...props}
          style={{
            ...props.style
          }}
        >
          {text}
        </BootstrapTooltip>
      )}
    </Overlay>
  )
}

export default Tooltip
